import { api } from '@/core/api/';
import utils from '@/utils/utilities';

const URL = 'api/contracttemplate';

export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const search = (payload) =>
  api.get(`${URL}/search`, {
    params: {
      ...payload,
    },
  });

export const getDetails = (contractTemplateId) =>
  api.get(`${URL}/details/${contractTemplateId}`);

export const requestinfo = () => api.get(`${URL}/requestinfo`);

export const getContractFields = (payload) =>
  api.post(`${URL}/templatefields`, payload);

export const detail = (contractTemplateId) =>
  api.get(`${URL}/detail/${contractTemplateId}`);

export const saveOrUpdateContractTemplate = (payload) =>
  api.post(`${URL}/saveorupdatecontracttemplate`, payload);

export const updateStatus = (id, payload) =>
  api.put(`${URL}/updatestatus/${id}`, payload);

export const downloadTemplate = (contractTemplateId) =>
  api
    .get(`${URL}/template/${contractTemplateId}`)
    .then((resp) => utils.convertToBlob(resp.data));
